<template>
    <div id="app">
        <Navigation></Navigation>
        <div class="container zmain-container" v-bind:class="{ 'zmain-container': currentUser && currentUser.uid != '' }">
    	    <router-view/>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Navigation from './components/Navigation.vue'
    import Footer from './components/Footer.vue'

    export default {
        components: { Navigation, Footer },
        computed: {
            ...mapState(['currentUser'])
        },
        watch: {
            $route(to, from) {
            // react to route changes...
            console.log("to", to, from);
            // if (this.$route.params.id) {
            //     this.userId = this.$route.params.id;
            //     this.viewUser();
            // }
            }
        },
    }
</script>

<style>
.main-container{
    margin-top: 30px;
    margin-bottom: 150px;
    @media screen and (min-width: $desktop) {
        margin: 30px 20px;
    }
    min-height: 55vh;    
}
</style>


// WEBPACK FOOTER //
// src/App.vue